import _ from 'lodash';
import React from 'react';
import uuid4 from 'uuid/v4';

import {formatDate} from 'utils/datetime';
import {
  CREATED_ACTION_STATUS,
  CUSTOMER_APPROVAL_GRANTED_ACTION_STATUS,
  CUSTOMER_APPROVAL_DENIED_ACTION_STATUS,
  SUBMITTED_ACTION_STATUS,
  CONFIRMED_ACTION_STATUS,
  CANCELLED_ACTION_STATUS,
  FAILED_ACTION_STATUS,
  CHARGED_BACK_ACTION_STATUS,
  CHARGEBACK_CANCELLED_ACTION_STATUS,
  PAID_OUT_ACTION_STATUS,
  LATE_FAILURE_SETTLED_OUT_ACTION_STATUS,
  CHARGEBACK_SETTLED_ACTION_STATUS,
  RESUBMISSION_REQUESTED_ACTION_STATUS
} from 'ducks/tenancy';

import yellowPlusCheckpoint from './assets/gc-created.svg';
import yellowDownCheckpoint from './assets/gc-submitted.svg';
import greenCheckCheckpoint from './assets/gc-confirmed.svg';
import redXCheckpoint from './assets/gc-failed.svg';
import bluePointsCheckpoint from './assets/gc-waiting.svg';
import greenDownCheckpoint from './assets/gc-paid.svg';

import './styles.css';

const ACTION_TO_CHECKPOINT_MAPPER = {
  [CREATED_ACTION_STATUS]: yellowPlusCheckpoint,
  [CUSTOMER_APPROVAL_GRANTED_ACTION_STATUS]: bluePointsCheckpoint, // TODO
  [CUSTOMER_APPROVAL_DENIED_ACTION_STATUS]: bluePointsCheckpoint, // TODO
  [SUBMITTED_ACTION_STATUS]: yellowDownCheckpoint,
  [CONFIRMED_ACTION_STATUS]: greenCheckCheckpoint,
  [CANCELLED_ACTION_STATUS]: bluePointsCheckpoint, // TODO
  [FAILED_ACTION_STATUS]: redXCheckpoint,
  [CHARGED_BACK_ACTION_STATUS]: bluePointsCheckpoint, // TODO
  [CHARGEBACK_CANCELLED_ACTION_STATUS]: bluePointsCheckpoint, // TODO
  [PAID_OUT_ACTION_STATUS]: greenDownCheckpoint,
  [LATE_FAILURE_SETTLED_OUT_ACTION_STATUS]: redXCheckpoint,
  [CHARGEBACK_SETTLED_ACTION_STATUS]: bluePointsCheckpoint, // TODO
  [RESUBMISSION_REQUESTED_ACTION_STATUS]: bluePointsCheckpoint
};

const Event = ({event}) => (
  <div className="Event">
    <div className="createdAt">{formatDate(event.createdAt)}</div>
    <div className="checkpoint">
      <img src={ACTION_TO_CHECKPOINT_MAPPER[event.action]} alt={event.action} />
      <div className="silverLine" />
    </div>
    <div className="info">
      <h4 className="action">{event.action}</h4>
      <p className="description">{event.description}</p>
    </div>
  </div>
);

const PaymentHistory = ({gocardlessPaymentEventsHistory}) => (
  <div className="PaymentHistory">
    <div className="horizontalLine" />
    <h3 className="header">Payment History</h3>
    {!_.isEmpty(gocardlessPaymentEventsHistory) && (
      <div className="events">
        {gocardlessPaymentEventsHistory.map(event => (
          <Event key={uuid4()} event={event} />
        ))}
      </div>
    )}
  </div>
);

export default PaymentHistory;
